
import { Vue } from "vue-class-component";

export default class Printer extends Vue {}
